module.exports = __webpack_public_path__ + "images/molenaar_small6ba44a962201e018f0aecee8bca410ad.png";